import React from 'react';

import { Box, Typography } from 'components';

type Props = {
  color?: string;
  label: string | number;
  icon: React.ElementType;
  highlightQuery?: string;
  iconStyle?: React.CSSProperties;
};

const highlightText = (text: string, query: string): React.ReactNode => {
  if (!query.trim()) return text;
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const parts = text.split(regex);
  return parts.map((part, index) =>
    regex.test(part) ? (
      <mark key={index} style={{ backgroundColor: '#ffff00' }}>
        {part}
      </mark>
    ) : (
      part
    ),
  );
};

export const CardBoxLabel: React.FC<Props> = ({
  label,
  icon: Icon,
  color = 'primary',
  highlightQuery,
  iconStyle,
}) => {
  if (label === null || label === undefined) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" paddingBottom="0.15rem">
      <Icon
        color={color}
        variant="TwoTone"
        size={18}
        style={{ flexShrink: 0, ...iconStyle }}
      />
      <Typography
        style={{
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 1,
          lineHeight: 1.35,
        }}
        paddingLeft="0.5rem"
        variant="body2"
        color="textSecondary"
      >
        {highlightQuery ? highlightText(String(label), highlightQuery) : label}
      </Typography>
    </Box>
  );
};
